import { VariantComplianceCoverage } from '../../react/components/article/variant/complianceCoverage/VariantComplianceCoverage';
import { ArticleNotFoundPage } from '../../react/components/article/ArticleNotFoundPage';
import { bridgeConverter } from '../../bridge/bridgeConverter';
import { SearchArticles } from '../../react/components/searchArticles/SearchArticles';
import { Navigation } from '../../react/components/navigation/Navigation';
import { Sales } from '../../react/components/article/variant/sales/Sales';
import { AvailableBranches } from '../../react/components/configuration/branches/AvailableBranches';
import { UserProfiles } from '../../react/components/users/keyAccountManager/UserProfiles';
import { ProjectContainer } from '../../react/components/customer/projects/ProjectContainer';
import { Dashboard } from '../../react/components/dashboard/Dashboard';
import { CustomersDirectory } from '../../react/components/customers/CustomersDirectory';
import { Treatments } from '../../react/components/configuration/treatments/Treatments';
import { Customer } from '../../react/components/customer/Customer';
import { CustomerLogo } from '../../react/components/customer/management/CustomerLogo';
import { BrandManagement } from '../../react/components/customer/management/BrandManagement';
import { DimensionGroups } from '../../react/components/configuration/dimensionGroups/DimensionGroups';
import { VariantSuppliers } from '../../react/components/article/variant/suppliers/VariantSuppliers';
import { AngularAddSupplier } from '../../react/components/article/variant/suppliers/AngularAddSupplier';
import { Qualities } from '../../react/components/configuration/qualities/Qualities';
import { ProductGroups } from '../../react/components/configuration/productGroups/ProductGroups';
import { ComplianceDocumentDefinitions } from '../../react/components/configuration/complianceDocumentDefinitions/ComplianceDocumentDefinitions';
import { Materials } from '../../react/components/configuration/materials/Materials';
import { CustomerContacts } from '../../react/components/customer/contacts/Contacts';
import { General } from '../../react/components/article/variant/general/General';
import { Versions } from '../../react/components/article/variant/versions/Versions';
import { ProductApprovalLockedMessage } from '../../react/components/shared/productApproval/LockedMessage';
import { CustomerProductApprovals } from '../../react/components/customer/productApprovals/CustomerProductApprovals';
import { ProductApprovals } from '../../react/components/article/productApproval/ProductApprovals';
import { NewConcept } from '../../react/components/customer/newConcept/NewConcept';
import { NewSupplier } from '../../react/components/suppliers/newSupplier/newSupplier';
import { NewCustomer } from '../../react/components/customer/newCustomer/NewCustomer';
import { FileBrowserTab } from '../../react/components/shared/files/FileBrowserTab';
import { MatrixCellPhoto } from '../../react/components/article/variant/matrix/MatrixCellPhoto';
import { Login } from '../../react/components/login/Login';
import { ResetPassword } from '../../react/components/login/ResetPassword';
import { Users } from '../../react/components/users/Users';
import { UserDetails } from '../../react/components/users/UserDetails';
import { ProductDevelopmentOverview } from '../../react/components/article/variant/overview/ProductDevelopmentOverview';
import { VariantOptions } from '../../react/components/article/variant/options/VariantOptions';
import { AngularContactsModal } from '../../react/components/customer/contacts/AngularContactsModal';
import { SupplierFileUploadZone } from '../../react/components/suppliers/SupplierFileUploadZone';
import { MatrixGridCell } from '../../react/components/article/variant/matrix/MatrixGridCell';
import { Organization } from '../../react/components/configuration/organization/Organization';
import { BranchRegions } from '../../react/components/configuration/branchRegions/BranchRegions';
import { Suppliers } from '../../react/components/suppliers/Suppliers';
import { SupplierManagement } from '../../react/components/suppliers/management/SupplierManagement';
import { SupplierWorkspaceHeader } from '../../react/components/suppliers/header/SupplierWorkspaceHeader';
import { SupplierComplianceDocuments } from '../../react/components/suppliers/complianceDocuments/SupplierComplianceDocuments';
import { SupplierContacts } from '../../react/components/suppliers/contacts/Contacts';
import { SupplierArticles } from '../../react/components/suppliers/articles/SupplierArticles';
import { SupplierProductGroups } from '../../react/components/suppliers/productGroups/SupplierProductGroups';
import { ArticleManagement } from '../../react/components/article/manage/ArticleManagement';
import { CreateArticlePage } from '../../react/components/article/create/CreateArticlePage';
import { CopyArticlePage } from '../../react/components/article/copy/CopyArticlePage';
import { CopyArticleButton } from '../../react/components/article/copy/CopyArticleButton';
import { CustomerUsers } from '../../react/components/customer/users/CustomerUsers';
import { CustomerComplianceDocuments } from '../../react/components/customer/complianceDocuments/CustomerComplianceDocuments';
import { ExternalUsers } from '../../react/components/customer/users/ExternalUsers';
import { Shipments } from '../../react/components/shipments/Shipments';
import { VdcPricing } from '../../react/components/vdc/VdcPricing';
import { VdcTemplates } from '../../react/components/configuration/vdcTemplates/VdcTemplates';
import { VdcTiers } from '../../react/components/configuration/vdcTiers/VdcTiers';
import { Tags } from '../../react/components/tags/Tags';
import { GarpVariantOverview } from '../../react/components/article/variant/garp/GarpVariantOverview';
import { Inquiries } from '../../react/components/article/variant/inquiry/Inquiries';
import { InquiryDetailPage } from '../../react/components/article/variant/inquiry/InquiryDetailPage';
import { ConceptManagement } from '../../react/components/customer/concept/management/ConceptManagement';
import { Offers } from '../../react/components/article/variant/offers/Offers';
import { OfferGroupDetailPage } from '../../react/components/article/variant/offers/OfferGroupDetailPage';
import { Jobs } from '../../react/components/jobs/Jobs';
import { JobDetails } from '../../react/components/jobs/JobDetails';
import { InternalApiKeys } from '../../react/components/configuration/internalApi/InternalApiKeys';
import { ConfigurationNavigation } from '../../react/components/configuration/navigation/ConfigurationNavigation';
import { CustomsCodes } from '../../react/components/configuration/customsCodes/CustomsCodes';
import { BranchTerms } from '../../react/components/configuration/branchTerms/BranchTerms';
import { BranchValues } from '../../react/components/configuration/branchValues/BranchValues';
import { FreightCosts } from '../../react/components/configuration/freightCost/FreightCosts';
import { HandlingFees } from '../../react/components/configuration/handlingsFees/HandlingFees';
import { Techniques } from '../../react/components/configuration/techniques/Techniques';
import { Branches } from '../../react/components/configuration/branches/Branches';
import { ArticleTags } from '../../react/components/configuration/articleTags/ArticleTags';
import { ArticleTemplates } from '../../react/components/configuration/articleTemplates/ArticleTemplates';
import { MatrixGroups } from '../../react/components/configuration/matrixGroups/MatrixGroups';
import { MatrixNodes } from '../../react/components/configuration/matrixNodes/MatrixNodes';
import { GarpConfiguration } from '../../react/components/configuration/garp/GarpConfiguration';
import { ArchivePage } from '../../react/components/archive/ArchivePage';
import { WeightDisplay } from '../../react/components/shared/weight/WeightDisplay';
import { WeightInput } from '../../react/components/shared/weight/WeightInput';

angular
  .module('app.bridgeComponents', [])
  .component('articleNotFoundPage', bridgeConverter(ArticleNotFoundPage, []))
  .component('searchArticles', bridgeConverter(SearchArticles, []))
  .component('archivePage', bridgeConverter(ArchivePage, ['resource']))
  .component(
    'weightInput',
    bridgeConverter(WeightInput, [
      'value',
      'onChange',
      'onValidityChange',
      'rules',
      'isDisabled',
      'contextKey',
    ]),
  )
  .component(
    'weightDisplay',
    bridgeConverter(WeightDisplay, ['value', 'conversionOnly']),
  )
  .component('vdcPricing', bridgeConverter(VdcPricing, []))
  .component('customerUsers', bridgeConverter(CustomerUsers, ['customerId']))
  .component(
    'customerComplianceDocuments',
    bridgeConverter(CustomerComplianceDocuments, [
      'customerId',
      'customerName',
      'customerArchived',
    ]),
  )
  .component(
    'externalUsers',
    bridgeConverter(ExternalUsers, ['customerId', 'customerName']),
  )
  .component('transportRequests', bridgeConverter(Shipments, []))
  .component(
    'customerContacts',
    bridgeConverter(CustomerContacts, ['customerId', 'customerName']),
  )
  .component(
    'supplierManagement',
    bridgeConverter(SupplierManagement, ['supplierId']),
  )
  .component(
    'supplierWorkspaceHeader',
    bridgeConverter(SupplierWorkspaceHeader, ['supplierId']),
  )
  .component(
    'supplierComplianceDocuments',
    bridgeConverter(SupplierComplianceDocuments, [
      'supplierId',
      'documentsFolderId',
    ]),
  )
  .component(
    'sales',
    bridgeConverter(Sales, [
      'articleId',
      'variantId',
      'customerId',
      'articleNodeGroup',
    ]),
  )
  .component('availableBranches', bridgeConverter(AvailableBranches, []))
  .component('users', bridgeConverter(Users, []))
  .component('jobs', bridgeConverter(Jobs, []))
  .component('jobDetails', bridgeConverter(JobDetails, ['jobId']))
  .component('userDetails', bridgeConverter(UserDetails, ['userId']))
  .component('userProfiles', bridgeConverter(UserProfiles, ['userId']))
  .component('appNavigation', bridgeConverter(Navigation, []))
  .component(
    'configurationNavigation',
    bridgeConverter(ConfigurationNavigation, ['organizationName']),
  )
  .component('branchTerms', bridgeConverter(BranchTerms, ['kind']))
  .component('branchValues', bridgeConverter(BranchValues, ['kind']))
  .component('customsCodes', bridgeConverter(CustomsCodes, []))
  .component('freightCosts', bridgeConverter(FreightCosts, []))
  .component('handlingFees', bridgeConverter(HandlingFees, []))
  .component('techniques', bridgeConverter(Techniques, []))
  .component('branches', bridgeConverter(Branches, []))
  .component('articleTags', bridgeConverter(ArticleTags, []))
  .component('articleTemplates', bridgeConverter(ArticleTemplates, []))
  .component('matrixGroups', bridgeConverter(MatrixGroups, []))
  .component('matrixNodes', bridgeConverter(MatrixNodes, []))
  .component('garpConfiguration', bridgeConverter(GarpConfiguration, []))
  .component(
    'angularContactsModal',
    bridgeConverter(AngularContactsModal, ['customerId', 'customerName']),
  )
  .component(
    'projectContainer',
    bridgeConverter(ProjectContainer, [
      'customerId',
      'brandName',
      'identifier',
      'keyAccountManagerId',
      'customerArchived',
    ]),
  )
  .component('treatments', bridgeConverter(Treatments, []))
  .component(
    'productDevelopmentOverview',
    bridgeConverter(ProductDevelopmentOverview, ['isMatrix', 'variantId']),
  )
  .component(
    'variantOptions',
    bridgeConverter(VariantOptions, ['variantId', 'articleNodeGroup', 'isVdc']),
  )
  .component(
    'customer',
    bridgeConverter(Customer, ['customerId', 'conceptId', 'conceptCustomerId']),
  )
  .component(
    'customerLogo',
    bridgeConverter(CustomerLogo, ['customerId', 'folderId', 'fileId']),
  )
  .component(
    'variantSuppliers',
    bridgeConverter(VariantSuppliers, ['articleId', 'variantId', 'pdVariant']),
  )
  .component(
    'variantComplianceCoverage',
    bridgeConverter(VariantComplianceCoverage, ['articleId', 'variantId']),
  )
  .component('angularAddSupplier', bridgeConverter(AngularAddSupplier, []))
  .component('qualities', bridgeConverter(Qualities, []))
  .component('productGroups', bridgeConverter(ProductGroups, []))
  .component(
    'complianceDocumentDefinitions',
    bridgeConverter(ComplianceDocumentDefinitions, ['folderId']),
  )
  .component('dimensionGroups', bridgeConverter(DimensionGroups, ['folderId']))
  .component('materials', bridgeConverter(Materials, []))
  .component('dashboard', bridgeConverter(Dashboard, []))
  .component('customerDirectory', bridgeConverter(CustomersDirectory, []))
  .component('newSupplier', bridgeConverter(NewSupplier, []))
  .component('branchRegions', bridgeConverter(BranchRegions, []))
  .component('general', bridgeConverter(General, ['id']))
  .component('login', bridgeConverter(Login, []))
  .component('resetPassword', bridgeConverter(ResetPassword, []))
  .component(
    'versions',
    bridgeConverter(Versions, ['variantId', 'articleNodeGroup']),
  )
  .component(
    'lockedMessage',
    bridgeConverter(ProductApprovalLockedMessage, [
      'variantId',
      'branchId',
      'matrixNodeXId',
      'matrixNodeYId',
      'isOnlyInfo',
    ]),
  )
  .component('newConcept', bridgeConverter(NewConcept, ['customerId']))
  .component(
    'customerProductApprovals',
    bridgeConverter(CustomerProductApprovals, ['customerId']),
  )
  .component(
    'productApproval',
    bridgeConverter(ProductApprovals, ['articleId', 'folderId']),
  )
  .component(
    'brandManagement',
    bridgeConverter(BrandManagement, ['customerId']),
  )
  .component('newCustomer', bridgeConverter(NewCustomer, []))
  .component(
    'fileBrowserTab',
    bridgeConverter(FileBrowserTab, ['rootFolderId', 'isArticle']),
  )
  .component(
    'matrixCellPhoto',
    bridgeConverter(MatrixCellPhoto, [
      'cellX',
      'cellY',
      'variantId',
      'folderId',
    ]),
  )
  .component(
    'matrixGridCell',
    bridgeConverter(MatrixGridCell, [
      'variantId',
      'folderId',
      'colField',
      'photoIdentifier',
    ]),
  )
  .component(
    'supplierFileUploadZone',
    bridgeConverter(SupplierFileUploadZone, [
      'emailFolderId',
      'documentsFolderId',
      'samplesFolderId',
    ]),
  )
  .component(
    'organization',
    bridgeConverter(Organization, ['organizationId', 'fileId', 'folderId']),
  )
  .component('suppliers', bridgeConverter(Suppliers, []))
  .component(
    'supplierContacts',
    bridgeConverter(SupplierContacts, ['supplierId', 'supplierName']),
  )
  .component(
    'supplierArticles',
    bridgeConverter(SupplierArticles, ['supplierId']),
  )
  .component(
    'supplierProductGroups',
    bridgeConverter(SupplierProductGroups, ['supplierId']),
  )
  .component(
    'articleManagement',
    bridgeConverter(ArticleManagement, ['articleId', 'onConfigure', 'onCopy']),
  )
  .component(
    'createArticlePage',
    bridgeConverter(CreateArticlePage, ['customerId', 'conceptId']),
  )
  .component(
    'copyArticlePage',
    bridgeConverter(CopyArticlePage, [
      'sourceArticleId',
      'customerId',
      'conceptId',
    ]),
  )
  .component(
    'copyArticleButton',
    bridgeConverter(CopyArticleButton, [
      'sourceArticleId',
      'customerId',
      'conceptId',
    ]),
  )
  .component('vdcTemplates', bridgeConverter(VdcTemplates, []))
  .component('vdcTiers', bridgeConverter(VdcTiers, []))
  .component('internalApiKeys', bridgeConverter(InternalApiKeys, []))
  .component('tags', bridgeConverter(Tags, []))
  .component(
    'garpVariantOverview',
    bridgeConverter(GarpVariantOverview, [
      'articleId',
      'variantId',
      'branchId',
    ]),
  )
  .component('management', bridgeConverter(ConceptManagement, ['concept']))
  .component(
    'inquiry',
    bridgeConverter(Inquiries, [
      'variantId',
      'articleNodeGroup',
      'initialBranchId',
      'initialSupplierId',
      'initialLifecycle',
    ]),
  )
  .component(
    'inquiryDetailPage',
    bridgeConverter(InquiryDetailPage, ['inquiryId', 'variantId']),
  )
  .component(
    'offerGroupDetailPage',
    bridgeConverter(OfferGroupDetailPage, ['offerGroupId', 'variantId']),
  )
  .component('offers', bridgeConverter(Offers, ['variantId']));
